import { render } from "./ChirpItem.vue?vue&type=template&id=3bfd5fc2&ts=true"
import script from "./ChirpItem.vue?vue&type=script&lang=ts"
export * from "./ChirpItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__